import { useState, useEffect, useRef } from 'react';
import api from '@/services/ApiService';

const cache = new Map();

export const ApiAggregation = ({
  id = null,
  resource = 'party',
  filter = null,
  mapResponse,
  placeholder = '...',
}) => {
  const [value, setValue] = useState(placeholder);
  const mountedRef = useRef(true);

  function defaultMap(data) {
    if (!data || !data?.title) return null;
    return `${data.title || ''}`.trim() || null;
  }

  useEffect(() => {
    mountedRef.current = true;
    if (!id) {
      setValue('');
      return;
    }
    const cacheKey = `${resource}-${id}-${filter || ''}`;
    if (cache.has(cacheKey)) {
      setValue(cache.get(cacheKey));
      return;
    }
    const fetchData = async () => {
      try {
        const { data } = await api.get(
          `/${resource}${id ? `/${id}` : ''}${filter ? `?${filter}` : ''}`,
        );
        const mapped =
          typeof mapResponse === 'function'
            ? mapResponse(data)
            : defaultMap(data);
        const final = mapped ?? data?.title ?? '—';
        if (mountedRef.current) {
          setValue(final);
          cache.set(cacheKey, final);
        }
        // eslint-disable-next-line no-unused-vars
      } catch (err) {
        if (mountedRef.current) setValue('Fehler beim Laden');
      }
    };

    fetchData();
    return () => {
      mountedRef.current = false;
    };
  }, [id, resource, filter, mapResponse]);

  return <span>{value}</span>;
};
